import { render, staticRenderFns } from "./authorized.vue?vue&type=template&id=4490ace0&scoped=true"
import script from "./authorized.vue?vue&type=script&lang=js"
export * from "./authorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4490ace0",
  null
  
)

export default component.exports